
angular.module('bmsApp.sm.job')
	.factory('SMRugCleaningPhotoSvc', [
		'CRUDSvc',
		function (CRUDSvc) {

			return {
				index: function (params) {
					return CRUDSvc.get('api/sm/job/rug-cleaning-photos/index', params);
				},
			}
		}]);




